'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from 'next/image';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { ProductBadge } from '@eliadmin/core/src/components/product/detail/product-badge';
import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { useState } from 'react';

export function ReferenceCard({ reference }: { reference: Reference }) {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  const allImages = [reference?.image, ...(reference?.images || [])]
    .filter(Boolean)
    .map((img, index) => ({
      url: img.url,
      name: `${reference.name}-image-${index}`,
    }));

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <div
        onClick={handleOpenGallery(allImages, 0)}
        className="relative col-span-1 flex w-full cursor-pointer flex-col items-start justify-between gap-[90px] overflow-hidden rounded-[4px] p-3 sm:gap-[120px] sm:p-4 md:gap-[140px] lg:gap-[184px] lg:p-6"
      >
        <div className="relative z-10 flex w-full flex-wrap items-start justify-start gap-2">
          <ProductBadge background="#F1E4DE" color="#3E1C12" text={'Interiér'} />
        </div>
        <div className="relative z-10 flex w-full flex-col items-start justify-start gap-2 sm:gap-3">
          <Heading
            title={reference.name}
            tag="h3"
            color="white"
            className={{ title: 'h-[58px] sm:h-[63px]' }}
          />
          <Paragraph size="lg" color="white" className="h-[23px]">
            {reference.city}
          </Paragraph>
        </div>
        <div className="ea-categories-card__image-overlay absolute inset-0 z-[1] transition-opacity duration-300 group-hover:opacity-0" />
        <Image
          src={reference?.image?.url ?? '/images/placeholder.png'}
          alt={resolveImageAlt(reference?.image, reference?.name)}
          fill
          className="absolute inset-0 z-0 h-full w-full object-cover object-center"
        />
      </div>
    </>
  );
}

export function ReferenceCardSkeleton() {
  return (
    <div
      className={cn(
        'col-span-1 h-[250px] w-full animate-pulse rounded-[4px] bg-neutral-100 sm:h-[280px] lg:h-[325px]',
      )}
    />
  );
}
